import React, { useState, createContext } from "react";

export const SocketStateContext = createContext();

export const SocketStateProvider = (props) => {
  const [socketInfo, setSocketInfo] = useState({
    user: { username: "", email: "" },
    room: { id: "", name: "" },
    isJoined: false,
  });

  return (
    <SocketStateContext.Provider value={[socketInfo, setSocketInfo]}>
      {props.children}
    </SocketStateContext.Provider>
  );
};
